import { IonContent, IonPage, IonImg, useIonViewDidLeave } from '@ionic/react';
import { useContext, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { PdfContext } from '../components/PdfViewer';

const AppAcademy = () => {
  const { setModalVisible, setDesktopPdf, setMobilePdf } = useContext(PdfContext);
  const [swiper, setSwiper] = useState<SwiperCore>();
  // set the swiper slide to the first one when the component is mounted
  useIonViewDidLeave(() => {
    swiper?.slideTo(0);
  }, [swiper]);
  return (
    <>
      <IonPage>
        <IonContent fullscreen>
          <Swiper
            initialSlide={0}
            modules={[Navigation, Pagination, Scrollbar, A11y]}
            onSwiper={(swiper) => setSwiper(swiper)}
            slidesPerView={1}
            navigation
            pagination={{ clickable: true }}
            spaceBetween={0}
            centeredSlides={true}
            breakpoints={{
              768: {
                slidesPerView: 1.2,
                spaceBetween: -20
              },
              1024: {
                slidesPerView: 1.4,
                spaceBetween: -120
              },
            }}
          >
            <SwiperSlide>
              <div className="container-inner app-academy">
                <div className="d-flex">
                  <h1 className='container-title' style={{ background: '#9c00ff', color: '#fff' }}>Kelas Aplikasi</h1>
                  <div className='container-content' style={{ background: '#fff', color: '#303030', paddingTop: '0.1rem' }}>
                    <p>
                      Akademi Aplikasi membantu kamu untuk lebih paham cara menggunakan Tinder secara lebih baik. Akademi ini akan memberi tahu semua fitur keren yang mungkin kamu lewatkan (yup, menyukai dan bisa cocok sama orang dari negara yang berbeda itu ada fiturnya) dan juga tentang fitur keren Jelajah. Setelah kamu menjelajah sesi ini, jangan kaget kalau banyak match baru yang bisa kamu dapatkan!
                    </p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            {/* <SwiperSlide>
            <div className="container-inner design-video">
              <div className="d-flex">
                <h1 className='container-title'>Heading of the video</h1>
                <div className='container-content'>
                  <div className="video-container">
                    <div className="thumbnail">
                      <IonImg src='assets/img/video-thumb.png'></IonImg>
                    </div>
                    <div className="description-outer">
                      <div className="description">
                        <h3 className='title'>
                          Video title
                        </h3>
                        <p>Video subtitle, this is a dummy description, lorem ipsum dolor sit amet.</p>
                      </div>
                      <a href="/">CLICK TO VIEW</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide> */}
            <SwiperSlide>
              <div className="container-inner design-one">
                <div className="d-flex">
                  <h1 className='container-title' style={{ background: '#ff00ae', color: '#fff' }}>Bikin profil kamu glow-up</h1>
                  <div className='container-content' style={{ background: '#fff', color: '#303030' }}>
                    <p className='hide-desktop' >Solusi dari setiap permasalahan profil kamu - dari memilih foto sampai menulis bio yang tepat! </p>
                    <IonImg src='assets/img/aa-profile-pro-thumb-01.png'></IonImg>
                    <div className='flex'>
                      <p className='hide-mobile' style={{ maxWidth: '550px' }}>Solusi dari setiap permasalahan profil kamu - dari memilih foto sampai menulis bio yang tepat! </p>
                      <button style={{ color: "#fff", background: "#ff00ae" }} onClick={() => {
                        setDesktopPdf("/assets/pdf/ID_TheProfileProject.pdf");
                        setMobilePdf("/assets/pdf/ID_TheProfileProject.pdf");
                        setModalVisible(true);
                      }}>Yuk, jadi profile-pro</button>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="container-inner design-one">
                <div className="d-flex">
                  <h1 className='container-title' style={{ background: '#26e8c8', color: '#fff' }}>Tentang Jelajah</h1>
                  <div className='container-content' style={{ background: '#fff', color: '#303030' }}>
                    <p className='hide-desktop'>Pilih minatmu dan bertemu dengan mereka yang sama dengan kamu.</p>
                    <IonImg src='assets/img/aa-explore-thumb-01.png'></IonImg>
                    <div className='flex'>
                      <p className='hide-mobile' style={{ maxWidth: '550px' }}>Pilih minatmu dan bertemu dengan mereka yang sama dengan kamu.</p>
                      <button onClick={() => {
                        setDesktopPdf("/assets/pdf/ID_Explore.pdf");
                        setMobilePdf("/assets/pdf/ID_Explore(m).pdf");
                        setModalVisible(true);
                      }} style={{ color: "#fff", background: "#26e8c8" }}>Jelajah bareng yuk!</button>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="container-inner design-one">
                <div className="d-flex">
                  <h1 className='container-title' style={{ background: '#298cfb', color: '#fff' }}>Kenalan dengan Fitur Tinder</h1>
                  <div className='container-content' style={{ background: '#fff', color: '#303030' }}>
                    <p className='hide-desktop'>Fitur handal yang bakal bikin pengalaman kamu di Tinder jadi makin seru.</p>
                    <IonImg src='assets/img/aa-flex-thumb-01.png' style={{ objectPosition: 'bottom' }}></IonImg>
                    <div className='flex'>
                      <p className='hide-mobile' style={{ maxWidth: '550px' }}>Fitur handal yang bakal bikin pengalaman kamu di Tinder jadi makin seru.</p>
                      <button onClick={() => {
                        setDesktopPdf("/assets/pdf/ID_Features.pdf");
                        setMobilePdf("/assets/pdf/ID_Features(m).pdf");
                        setModalVisible(true);
                      }} style={{ color: "#fff", background: "#298cfb" }}>Cek lebih lanjut!</button>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="container-inner design-one">
                <div className="d-flex">
                  <h1 className='container-title' style={{ background: '#ff5599', color: '#fff' }}>Cara Menghindari Obrolan Yang Garing</h1>
                  <div className='container-content' style={{ background: '#fff', color: '#303030' }}>
                    <p className='hide-desktop'>Kuasai ice-breaking dan bikin percakapan seru - tingkatkan kemampuan ngobrol kamu dengan tips-tips ini! </p>
                    <IonImg src='assets/img/aa-dry-convos-thumb-01.png'></IonImg>
                    <div className='flex'>
                      <p className='hide-mobile' style={{ maxWidth: '550px' }}>Kuasai ice-breaking dan bikin percakapan seru - tingkatkan kemampuan ngobrol kamu dengan tips-tips ini!</p>
                      <button onClick={() => {
                        setDesktopPdf("/assets/pdf/ID_AvoidDryConvo.pdf");
                        setMobilePdf("/assets/pdf/ID_AvoidDryConvo(m).pdf");
                        setModalVisible(true);
                      }} style={{ color: "#fff", background: "#ff5599" }}>Mulai mengetik</button>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </IonContent >
      </IonPage >
    </>
  );
};

export default AppAcademy;